import types from './errorHandlerTypes';

export const setHistory = data => ({
  type: types.SET_HISTORY,
  payload: data,
});
